export const getThemes = state => {
  return state.themes
}

export const getThemesIds = state => {
  return state.themes.map(el => el.id)
}

export const getThemeById = state => id => {
  return state.themes.find(el => el.id === id)
}

// current theme depending on the router path
export const currentTheme = (state, getters, rootState) => {
  const id = rootState.route.params.themeId

  if (state.currentTheme) return state.currentTheme

  if (!id) {
    return null
  }
  return state.themes.find(el => el.id === id)
}

// compute the lessonStep duration from the lesson duration
export const themeDuration = (state, getters) => themeId => {
  const theme = getters.getThemeById(themeId)
  const lessonSteps = (theme && theme.lessonSteps) || []

  return lessonSteps.reduce((duration, lessonStep) => {
    const lessonStepDuration = getters.lessonStepDuration(lessonStep.id)

    if (!lessonStepDuration) return duration

    return duration + lessonStepDuration
  }, 0)
}


export const themeFunnels = state => state.funnels
